import { checkPropTypes } from 'prop-types';

var charLength = function charLength(length, proptypes) {
  return function (props, propName, componentName) {
    var _checkPropTypes;

    var MAX_CHARS = length;
    var valueProp = props[propName];
    checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = proptypes, _checkPropTypes), props, 'prop', componentName);

    if (!isNaN(valueProp) && valueProp.toString().length > MAX_CHARS) {
      return new Error("Invalid prop " + propName + " supplied to " + componentName + ". " + propName + " must have up to " + MAX_CHARS + " characters");
    }

    return null;
  };
};

export default charLength;